import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { Popover } from '@/components/molecules/Popover'

interface IPinConversationRepliesAlertProps {
  isOpen: boolean
  repliesNumber: number
  onDismiss: () => void
  onConfirm: () => void
}

export const PinConversationRepliesAlert: FC<
  IPinConversationRepliesAlertProps
> = ({ isOpen, repliesNumber, onDismiss, onConfirm }) => {
  const { t } = useTranslation('common')

  return (
    <Popover
      hasIcon
      isOpen={isOpen}
      onDismiss={onDismiss}
      onConfirm={onConfirm}
      onConfirmClassName="normal-case text-red-500 font-bold order-first"
      onDismissClassName="normal-case"
      actionText={t('no')}
      confirmText={t('yes')}
    >
      {t('UGC.conversation.pinRepliesConfirmationMessage', {
        count: repliesNumber,
      })}
    </Popover>
  )
}
